import { Link } from "react-router-dom";

/**
 * FanFuel buttons.
 * primary  = pill, ember fill, dark text, glow on hover
 * secondary = sharp, outlined ghost
 */
const base =
  "inline-flex items-center justify-center gap-2 font-semibold transition-all duration-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-ff-ember focus-visible:ring-offset-2 focus-visible:ring-offset-ff-midnight disabled:opacity-60 disabled:pointer-events-none";

const variants = {
  primary:
    "rounded-full bg-ff-ember px-7 py-3.5 text-sm tracking-wide text-ff-midnight hover:-translate-y-0.5 hover:shadow-[0_10px_30px_-6px_rgba(255,75,34,0.55)]",
  secondary:
    "rounded-md border border-ff-grey/30 bg-transparent px-7 py-3.5 text-sm tracking-wide text-ff-ivory hover:bg-ff-ivory/10 hover:border-ff-ivory/50",
  ghost:
    "rounded-md px-4 py-2 text-sm text-ff-grey hover:text-ff-ivory",
};

export const FButton = ({ variant = "primary", to, href, className = "", children, ...props }) => {
  const cls = `${base} ${variants[variant]} ${className}`;
  if (to) return <Link to={to} className={cls} {...props}>{children}</Link>;
  if (href) return <a href={href} className={cls} {...props}>{children}</a>;
  return <button className={cls} {...props}>{children}</button>;
};

export default FButton;
